import React, { useState } from 'react';
import { Columns, ChevronDown, ChevronRight } from 'lucide-react';
import type { ComparisonTableWidgetData } from '../../../types/agentWidgets';

interface Props {
  data: ComparisonTableWidgetData;
}

export const ComparisonTableWidget: React.FC<Props> = ({ data }) => {
  const [collapsed, setCollapsed] = useState(false);

  if (!data.rows || data.rows.length === 0) return null;

  return (
    <div className="bg-indigo-50/30 dark:bg-indigo-900/5 border-l-3 border-indigo-400 dark:border-indigo-600">
      <button
        onClick={() => setCollapsed(!collapsed)}
        className="flex items-center gap-2 w-full px-3 py-2 text-left hover:bg-indigo-50/50 dark:hover:bg-indigo-900/10 transition-colors"
      >
        {collapsed ? <ChevronRight className="h-3.5 w-3.5 text-indigo-600 dark:text-indigo-400 flex-shrink-0" /> : <ChevronDown className="h-3.5 w-3.5 text-indigo-600 dark:text-indigo-400 flex-shrink-0" />}
        <Columns className="h-3.5 w-3.5 text-indigo-600 dark:text-indigo-400 flex-shrink-0" />
        <span className="text-xs font-semibold text-gray-800 dark:text-gray-200">
          {data.title}
        </span>
        <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400">
          {data.columns.length} columns
        </span>
      </button>

      {!collapsed && (
        <div className="px-3 pb-3 overflow-x-auto">
          <table className="w-full text-[11px] border-collapse table-fixed">
            <thead>
              <tr>
                <th className="w-[22%] text-left px-2 py-1.5 font-semibold text-gray-600 dark:text-gray-400 bg-indigo-50/50 dark:bg-indigo-900/10 border-b border-indigo-100 dark:border-indigo-900/20" />
                {data.columns.map((col, i) => (
                  <th
                    key={i}
                    className="text-left px-2 py-1.5 font-semibold text-indigo-700 dark:text-indigo-300 bg-indigo-50/50 dark:bg-indigo-900/10 border-b border-indigo-100 dark:border-indigo-900/20"
                  >
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.rows.map((row, i) => (
                <tr key={i} className={i % 2 === 0 ? '' : 'bg-indigo-50/20 dark:bg-indigo-900/5'}>
                  <td className="px-2 py-1.5 font-medium text-gray-700 dark:text-gray-300 border-b border-gray-100 dark:border-medical-600 align-top break-words">
                    {row.label}
                  </td>
                  {row.cells.map((cell, j) => (
                    <td
                      key={j}
                      className="px-2 py-1.5 text-gray-600 dark:text-gray-400 border-b border-gray-100 dark:border-medical-600 align-top break-words"
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
